// removed by extract-text-webpack-plugin
module.exports = {"separator":"src-components-seperator----seperator-module---separator---2rZ62"};


//////////////////
// WEBPACK FOOTER
// ./src/components/seperator/seperator.module.pcss
// module id = 302
// module chunks = 104033720589488